import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const ZarazeniPov = {
	name: NAME,
	apiProvider,
	router,
};
